import React, { useMemo, useState } from 'react'
import { Scrollbars } from 'react-custom-scrollbars';

import useNotesContext from '../useNotesContext'

import Items from './Items';
import Modal from '../../../../../../loop-widgets/_Shared/Modal'
import PrivatePublicModal from '../modals/PrivatePublicModal'
import { Button, NoExistingNotesWrapper, NotePreview, SidebarWrapper } from '../styledcomponents'
import Header from '../Header';

function Sidebar() {
    const { addNewNotes, sidebarNotes, activeNote, collapsedSidebar } = useNotesContext()
    const [showCreateModal, setShowCreateModal] = useState(false)

    return useMemo(() => {
        const sidebarNotesKey: any = Object.keys(sidebarNotes)

        if(activeNote) {
            return <React.Fragment></React.Fragment>
        }

        return <React.Fragment>
            <Modal show={showCreateModal} overlayClicked={() => setShowCreateModal(false)}>
                <PrivatePublicModal submit={addNewNotes} callback={() => setShowCreateModal(false)} />
            </Modal>

            <Header />
            <SidebarWrapper collapsed={collapsedSidebar}>
                {
                    (sidebarNotesKey || [])?.length ?
                        <Scrollbars
                            autoHide
                            autoHideTimeout={1000}
                            autoHideDuration={200}
                            style={{ height: 'calc(100% - 5px)' }}
                        >
                            {
                                (sidebarNotesKey || []).map((notesKey: any, idx: number) => {
                                    return <Items
                                        key={`notes-item-${notesKey}`}
                                        id={notesKey || ''}
                                        isActive={notesKey === activeNote}
                                    />
                                })
                            }
                        </Scrollbars> : <NotePreview className="no-note list">
                            No notes
                        </NotePreview>
                }
            </SidebarWrapper>
        </React.Fragment>
    }, [JSON.stringify(sidebarNotes), showCreateModal, activeNote, collapsedSidebar])
}

export default Sidebar